import { convertAmount, formatAmount, isVolumeUnit, mlToOz, type RecipeLine } from '@muddle/core';

export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

const UNIT_LABEL: Record<string, string> = {
  oz: 'oz',
  ml: 'ml',
  dash: 'dash',
  barspoon: 'barspoon',
  drop: 'drop',
  piece: 'piece',
};

/** "0.75 oz", converting oz/ml to the chosen display unit; other units pass through. */
export function lineText(line: Pick<RecipeLine, 'amount' | 'unit'>, display: 'oz' | 'ml'): string {
  const unit = isVolumeUnit(line.unit) ? display : line.unit;
  const amount = convertAmount(line.amount, line.unit, display);
  let label = UNIT_LABEL[unit] ?? unit;
  if (!isVolumeUnit(unit) && amount !== 1) label = label === 'dash' ? 'dashes' : `${label}s`;
  return `${formatAmount(amount, unit === 'ml' ? 1 : 2)} ${label}`;
}

/** "≈ 18.7% ABV · ≈ 127 ml" (always labelled as an estimate by the caller). */
export function estimateText(
  abv: number | null,
  volumeMl: number | null,
  unit: 'oz' | 'ml',
): string {
  if (abv === null || volumeMl === null) return 'Not enough measured ingredients to estimate.';
  const vol =
    unit === 'oz' ? `${formatAmount(mlToOz(volumeMl), 1)} oz` : `${Math.round(volumeMl)} ml`;
  return `${abv.toFixed(1)}% ABV · ${vol}`;
}
